// =============================================
// SALES TREE REGISTRY - Sales-specific decision trees
// =============================================

export const salesTreeRegistry = [
  {
    id: "nathaniel",
    title: "AI Learning Labs / Nathaniel",
    description: "A next-steps qualifier for Nathaniel Reagan. Three gates to surface the right offer based on priority and investment level.",
    category: "Sales Pitch",
    gates: 3,
    route: "/sales/nathaniel",
  },
  {
    id: "aill-content-approval",
    title: "Sample Content Approval for AI Learning Labs",
    description: "A content operations approval flow. Walk through the gates to determine whether a piece of content should ship.",
    category: "Content Operations",
    gates: 7,
    route: "/sales/aill-content-approval",
  },
];

export default salesTreeRegistry;
